export default __webpack_public_path__ + "static/refill-ced1f0b464855a735b811f1b861d896d.mp4";